import { DataQuery } from '../../classroom360/data-query/models/data-query.model';
import { StudentList } from '../../classroom360/student-lists/student-list.model';

export class StudentSearchCriteria {

    // Constructors
    constructor(
        yearId: number,
        studentNumber: string,
        firstName: string,
        lastName: string,
        schoolId: string,
        status: string,
        viewAllStudentInThisSchoolYear = false,
        courseId = '0',
        listId = -1,
        enrollmentDate = null,
        getStudentHomerooms = false
    ) {
        this.yearId = yearId;
        this.studentNumber = studentNumber;
        this.lastName = lastName;
        this.firstName = firstName;
        this.schoolId = schoolId;
        this.status = status;
        this.viewAllStudentInThisSchoolYear = viewAllStudentInThisSchoolYear;
        this.courseId = courseId;
        this.listId = listId;
        this.enrollmentDate = enrollmentDate;
        this.getStudentHomerooms = getStudentHomerooms;
    }

    // Server Properties
    public yearId: number;
    public studentNumber: string;
    public lastName: string;
    public firstName: string;
    public schoolId: string;    // NOTE: the application treats this like a number, but it's really a string on the DTO
    public status: string;
    public viewAllStudentInThisSchoolYear = false;
    public courseId = '';
    public listId = -1;
    public enrollmentDate = null;
    public getStudentHomerooms = false;

    // Local Properties
    currentQuery: DataQuery = null;
    studentList: StudentList = null;
}
